/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How a winning team's prize is distributed. CAPTAIN_ONLY = whole prize to the captain (default). EVEN_ROSTER = split evenly across active roster members (floor division, remainder to captain).
 * @export
 */
export const TournamentPrizeSplit = {
    CAPTAIN_ONLY: 'CAPTAIN_ONLY',
    EVEN_ROSTER: 'EVEN_ROSTER'
} as const;
export type TournamentPrizeSplit = typeof TournamentPrizeSplit[keyof typeof TournamentPrizeSplit];


export function instanceOfTournamentPrizeSplit(value: any): boolean {
    for (const key in TournamentPrizeSplit) {
        if (Object.prototype.hasOwnProperty.call(TournamentPrizeSplit, key)) {
            if (TournamentPrizeSplit[key as keyof typeof TournamentPrizeSplit] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TournamentPrizeSplitFromJSON(json: any): TournamentPrizeSplit {
    return TournamentPrizeSplitFromJSONTyped(json, false);
}

export function TournamentPrizeSplitFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentPrizeSplit {
    return json as TournamentPrizeSplit;
}

export function TournamentPrizeSplitToJSON(value?: TournamentPrizeSplit | null): any {
    return value as any;
}

export function TournamentPrizeSplitToJSONTyped(value: any, ignoreDiscriminator: boolean): TournamentPrizeSplit {
    return value as TournamentPrizeSplit;
}

